import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/AuthService';
import { AuthGuard } from './auth.guard';
import { NgOptimizedImage, registerLocaleData } from "@angular/common";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { TranslatePipe } from "./pipes/TranslatePipe";
import { DialogService } from "primeng/dynamicdialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateService } from "./services/TranslateService";
import { NgxSpinnerModule } from "ngx-spinner";
import { AuthInterceptor } from "./guard/auth-interceptor";
import localeRu from '@angular/common/locales/ru';
import { SharedModule } from "./shared/sharedModule";
import { adminAuthGuard } from "./admin/admin-auth.guard";
import { clientAuthGuard } from "./client/client-auth.guard";
import { authInitFactory } from "./auth/auth-init.factory";
import { permissionGuard } from "./auth/permission.guard";

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [adminAuthGuard]
  },
  {
    path: 'client',
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
    canActivate: [clientAuthGuard]
  },
  {
    // ТВ-режим живого дашборда: без сайдбара админки, тот же модуль в режиме 'tv'.
    path: 'tv',
    loadChildren: () => import('./admin/sales-live/sales-live.module').then(m => m.SalesLiveModule),
    canActivate: [adminAuthGuard, permissionGuard('sales.board.view')],
    data: { mode: 'tv' },
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];

registerLocaleData(localeRu);

export function setupTranslateServiceFactory(service: TranslateService): Function {
  if (!localStorage.getItem('lang')) {
    localStorage.setItem('lang', 'ru.json');
  }
  const lang = localStorage.getItem('lang');
  return () => service.use(lang || 'ru.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmDialogComponent,
    TranslatePipe,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    }),
    NgOptimizedImage,
    NgxSpinnerModule.forRoot(),
    SharedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'ru' },
    AuthService,
    AuthGuard,
    DialogService,
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateServiceFactory,
      deps: [TranslateService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authInitFactory,
      deps: [AuthService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
